import React from "react";
import "../rayajin.ajinray.component.css";
import { Card, CardContent, CardMedia, Typography } from "@mui/material";
import six from "./sixyears.png"; // Replace with the correct path to image7
import { makeStyles } from "@mui/styles";

const useStyles = makeStyles({
  root: {
    minWidth: 275,
    width: "70%",
  },
  img: {
    paddingTop: "56.25%",
    marginTop: "30",
    width: "60%",
  },
});

const RayAjinSixYearsComponent = () => {
  const classes = useStyles();

  return (
    <div className="AjinRay">
      <div className="AjinRay-body">
        <Card className={classes.root} variant="outlined">
          <CardContent>
            <Typography variant="h5" component="h2">
              12÷2 Years
            </Typography>
            <br />
            <CardMedia>
              <img src={six} alt="Image 7" />
            </CardMedia>
            <br />
            <Typography variant="body1" component="p">
              I was just feeling special about this number 6. And I kept thinking why? 
              <br />
              And then why I started writing this, it just clicked me.
              <br />
              <br />
              It's half of 12. The most special number for her, for me. For US.
              <br />
              <br />
              Well, the US has not been functioning too well lately. So better to stick to my side of things I guess. So will just continue to say what I feel, what I think, what I want to say!!
              <br />
              <br />
              5th July 2020. When everyting started, from a late night message. 
              <br />
              <br />
              "Do you like me enough that you see a future?"
              <br />
              "Let's keep things as 'its complicated'"
              <br />
              <br />
              To being a married couple as of today!!
              <br />
              <br />
              Wow! We indeed have come a long way.
              <br />
              <br />
              But for the first time in last 6 years. I am actually struggling to write things here. It almost feels like things are back to "It's Complicated"!
              <br />
              <br  />
              But I can't let that happen. I mean she is still the same girl. I am still the same guy. 
              <br />
              Both still care for each other deeply. Both still can't see each other sad or crying. Both still thinking about each other. Both still carrying each other through. Both still thinking about each other to some extent.
              Both still loving each other. Both still seeing a future together.
              <br />
              <br />
              After all this, even after all this. Even after being broken. We both still see us together. 
              <br />
              <br />
              How? Just How?
              <br />
              <br />
              It has to be something bigger than Love. It has to be something divine. It has to be something planned by God. It has to be something beyond imaginable. It has to be something beyond human comprehension. It should be something designed by higher powers.
              <br />
              <br />

              Humans don't operate like this. They can't.  
              <br />
              May be she actually is an Angel. May be I am actually a Devta Paurush. 
              <br />
              <br />
              MAY BE
              <br />
              <br />
              And if that is the case, this is something that the universe will remember for ages to come. Both of us are meant for things bigger than ourselves. Bigger than the biggest. Bigger than anything ever seen. Bigger, better, bestestestestest.
              <br />
              <br />
              I don't know what it is yet. But I know it is going to be a spectacle. For everyone to see, and for us to experience. In each other's company. Witnessing each other doing wonders. Making the biggest of bets. Shining with the brightest of stars. And just being who they are.
              <br />
              <br />
              Who they were always meant to be!!
              <br />
              <br />
              RayAjin
              <br />
              The power couple.




            
            </Typography>
          </CardContent>
        </Card>
      </div>
    </div>
  );
};

export default RayAjinSixYearsComponent;